import React, { useReducer, useEffect } from 'react';
import { get, isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import axios from 'axios';
import { toast } from 'react-toastify';
import { withRouter } from 'react-router-dom';
import EspecialidadesStepReducer from '../../reducers/EspecialidadesStepReducer';
import { API_URL } from '../../../lib/const';
import EspecialidadeStep from '../components/EspecialidadeStep';

const EspecialidadeStepPage = ({ match, history, onClick, backClick }) => {
  const initialState = {
    loadingEspecialidades: false,
    submitting: false,
    especialidades: []
  };

  const { token } = match.params;
  const [state, dispatch] = useReducer(EspecialidadesStepReducer, initialState);
  const { loadingEspecialidades, submitting, especialidades } = state;

  const fetchEspecialidades = async () => {
    dispatch({ type: 'SET_ESPECIALIDADES_LOADING', payload: true });
    try {
      const res = await axios.get(
        `${API_URL}/eligible-onboardings-v2/${token}`
      );
      dispatch({ type: 'SET_ESPECIALIDADES', payload: res.data });
      console.log(res.data);
    } catch (error) {
      if (error.response.status === 422) {
        window.location.href = error.response.data.redirect_url;

      } else {
        toast.error(
          'Ocorreu um erro ao carregar sua especialidade. Por favor tente novamente.'
        );
      }

      dispatch({ type: 'SET_ESPECIALIDADES_LOADING', payload: false });
    }
  };

  const sendEspecialidade = async values => {
    dispatch({ type: 'SET_SUBMIT', payload: true });

    const params = isEmpty(values) ? { onboarding: null } : values;

    try {
      const res = await axios.patch(
        `${API_URL}/enrollment-choose/${token}/select-onboarding`,
        params
      );

      const newToken = get(res, 'data.token');

      if (newToken && newToken !== token) {
        history.replace(`/inscrever/${newToken}`);
      }

      onClick();
      dispatch({ type: 'SET_SUBMIT', payload: false });
    } catch (error) {
      const status = get(error, 'response.status');
      if (status === 400) {
        toast.error('Selecione uma especialidade');
      } else {
        toast.error(
          'Ocorreu um erro ao enviar sua especialidade. Por favor tente novamente.'
        );
      }
      dispatch({ type: 'SET_SUBMIT', payload: false });
    }
  };

  useEffect(() => {
    fetchEspecialidades();
  }, []);

  return (
    <EspecialidadeStep
      submitting={submitting}
      loadingEspecialidades={loadingEspecialidades}
      sendEspecialidade={sendEspecialidade}
      especialidades={especialidades}
      backClick={backClick}
    />
  );
};
EspecialidadeStepPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      token: PropTypes.string
    })
  }).isRequired,
  history: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  backClick: PropTypes.func
};

EspecialidadeStepPage.defaultProps = {
  onClick: () => {},
  backClick: () => {}
};

export default withRouter(EspecialidadeStepPage);
